import { ButtonProps } from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Unstable_Grid2";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { useCallback, useMemo, useState } from "react";
import { useQuery } from "react-query";
import { listProducts } from "../../../services/arts";
import { Dialog } from "../../Dialog";
import { useStyles } from "./styles";
import { ArtImage } from "../../ArtImage";
import { isEmpty, map } from "lodash";
import Typography from "@mui/material/Typography";
import { Product } from "../../../types/arts";

type DialogAddProductsProps = {
  open: boolean;
  onClose: () => void;
  onSave: (data: Product) => void;
};

export function DialogAddProducts({
  open,
  onClose,
  onSave,
}: DialogAddProductsProps) {
  const styles = useStyles();

  const [product, setProduct] = useState<string>("");

  const actions: ButtonProps[] = useMemo(() => {
    return [
      {
        children: "Fechar",
        onClick: onClose,
      },
    ];
  }, [onClose]);

  const products = useQuery(["products", product], () => listProducts(product));

  const handleSelectedProduct = useCallback(
    (data: Product) => {
      onSave(data);
    },
    [onSave]
  );

  return (
    <Dialog
      onClose={onClose}
      fullWidth
      maxWidth="md"
      title="Adicionar produto"
      open={open}
      actions={actions}
    >
      <Stack spacing={2} className={styles.root} alignItems="center">
        <TextField
          label="Produto"
          autoFocus
          value={product}
          onChange={({ target: { value } }) => setProduct(value)}
          fullWidth
          size="small"
        />
        {products.isLoading ? (
          <CircularProgress />
        ) : isEmpty(products.data) ? (
          <Typography textAlign="center" fontWeight={500}>
            Não encontramos nenhum produto
          </Typography>
        ) : (
          <Grid container spacing={2}>
            {map(products.data, (prod) => (
              <Grid xs={3}>
                <ArtImage
                  image={prod.imagem_produto}
                  name={prod.nome_produto}
                  onClick={() => {
                    handleSelectedProduct(prod);
                  }}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </Stack>
    </Dialog>
  );
}
